import { z } from 'zod';
import { ShadowSettingKeySchema, PaddingSettingSchema, TypographyTypeSchema } from '../setting';
import { TipTapContentSchema } from '../tiptap-content.schema';
import { BasePinComponentSchema, BasePinComponentSettingsSchema } from './base-pin-component';

const TextHorizontalAlignmentSchema = z.enum(['left', 'center', 'right', 'justify']);
const TextVerticalAlignmentSchema = z.enum(['baseline', 'center', 'end']);

const DropZonePinComponentImageSchema = z.object({
  name: z.string(),
  url: z.string(),
});

export type DropZonePinComponentImage = z.infer<typeof DropZonePinComponentImageSchema>;

export const DropZonePinComponentPinThemeSettingsSchema = z.object({
  backgroundColor: z.string().optional(),
  borderSize: z.number().optional(),
  borderColor: z.string().optional(),
  borderRadius: z.number().optional(),
  shadow: ShadowSettingKeySchema,
  padding: PaddingSettingSchema.optional(),
  fontShadow: ShadowSettingKeySchema,
  fontFamily: z.string().optional(),
  fontSize: z.string().optional(),
  fontWeight: z.string().optional(),
  fontColor: z.string().optional(),
});
export type DropZonePinComponentSettingsTheme = z.infer<typeof DropZonePinComponentPinThemeSettingsSchema>;

const DropZonePinComponentSettingsSchema = BasePinComponentSettingsSchema.extend(
  DropZonePinComponentPinThemeSettingsSchema.extend(
    z.object({
      textStyleKey: z.string().optional(),
      typographyKey: TypographyTypeSchema.optional(),
      horizontalAlignment: TextHorizontalAlignmentSchema.optional(),
      verticalAlignment: TextVerticalAlignmentSchema.optional(),
      textFill: TipTapContentSchema,
      imageFill: DropZonePinComponentImageSchema.optional(),
    }).shape
  ).shape
);
export type DropZonePinComponentSettings = z.infer<typeof DropZonePinComponentSettingsSchema>;

export const DropZonePinComponentTypeSchema = z.literal('DROP_ZONE');

export const DropZonePinComponentSchema = BasePinComponentSchema.extend(
  z.object({
    type: DropZonePinComponentTypeSchema,
    settings: DropZonePinComponentSettingsSchema,
  }).shape
);
